<div class="ui-tooltip ui-tooltip-{{position}}">
  <div class="ui-tooltip-title">{{title}}</div>
  <div class="ui-tooltip-text">{{description}}</div>
</div>
